import { Component, OnInit, Input } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TableEditComponent } from './table-edit/table-edit.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  @Input() tableDef=null;

  isData:boolean = true;
  isReadOnly:boolean = false;
  
  data = [];
  loading = false;
  selectedRow = null;


  constructor(private http: HttpClient,
    public dialog: MatDialog,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {

    // initialise
    this.loading = false;
    this.data = [];
        
    if(this.tableDef["readOnly"] && this.tableDef["readOnly"]===true){
      this.isReadOnly = true;
    }

    // get the data ...
    this.loadData();

  }

  loadData() {
    
    this.loading = true;
    let apiName = "";
    if(this.tableDef.tableName === 'accounts'){
      apiName = "adminaccounts";
    }else{
      apiName = this.tableDef.tableName;
    }

    this.http.get("/api/data/" + apiName).subscribe(
      (response: any) => {
        const rtn = response;
        this.loading = false;
        this.data = response
        
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get data');
        console.log(error);
      }
    );
  }

  updateData(data){
    
    this.loading = true;

    if(this.tableDef.tableName == "accounts"){
      delete data.entitylastchanged;
      if(data['hideParent']){
        delete data.hideParent;
      }
    }

    let body = new HttpParams();
    Object.keys(data).forEach(x => {
      body = body.append(x,data[x]==null ? "" :data[x] );
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post("/api/data/" + this.tableDef.tableName, body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row

          const rtnid = response["id"];
          const rtndata = response["data"][0];

          let found = false;
          this.data.forEach((x,i) => {
            if(x["id"]==rtnid){
              found = true;
              this.data[i] = rtndata;
            }
          });

          if(!found) this.data.push(rtndata);
          this.loading = false;
        }

      }, (error: any) => {
        let message="Unable to update the Table"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );
  }

  deleteData(data){

    // turn the data object into form data to post
    let body = new HttpParams().append("id",data["id"]);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const options = {
      headers:headers,
      body: body
    }

    this.http.delete("/api/data/" + this.tableDef.tableName, options)
    .subscribe(
      (response: any) => {

        if(response.success){
          // get the id of the deleted row and remove that from the data
          const rtnid = response["id"];                  
          this.data = this.data.filter(x => (x["id"]!=rtnid));
              
        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to delete the Table"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }

  selectRow(id){
    this.selectedRow = id;
  }

  addTable(){
    this.openTableEdit({});
  }

  editTable(id){
    // find the data row and pass to the edit    
    this.selectedRow = id;
    const d = this.data.filter(x => (x.id == this.selectedRow))
    if(d.length==1){
      if(this.tableDef.tableName == "accounts"){
        let childs = this.data.filter(x => (x.parentid == id));
        if(childs.length>0){
          d[0]['hideParent'] = true;
        }
      }
      this.openTableEdit(d[0]); 
    }   
  }

  openTableEdit(data){

    let newdata = this.deepCopy(data);

    let tableEdit = {
      tableDef: this.tableDef,
      data: newdata
    }
    
    let dialogRef = this.dialog.open(TableEditComponent, {
      height: '600px',
      width: '750px',
      data: tableEdit      
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){

      } else if(result=="delete"){

        // delete from the database
        this.deleteData(newdata)

      } else if(result!=undefined){

        // save to the database
        this.updateData(result)
        
      }
    })  
  }

    // deep copy of Object
    private deepCopy(obj) {
      return Object.keys(obj).reduce((v, d) => Object.assign(v, {
        [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
      }), {});
    }
  
    private deepCopyArray(arr){
      let narray = [];
      arr.forEach(el => {
        narray.push(this.deepCopy(el))
      });
      return narray
    }

}
